import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../../store'
interface IErrorPopupSliceState {
  errorMessage?: string
}

const initialState: IErrorPopupSliceState = {
  errorMessage: ''
}

const Slice = createSlice({
  name: '@shared/errorpopup',
  initialState,
  reducers: {
    SetErrorPopupMessage: (state, action: PayloadAction<string>) => {
      return { ...state, errorMessage: action.payload }
    }
  }
})

export const { SetErrorPopupMessage } = Slice.actions
export const getErrorPopupMessage = (state: RootState) => state.shared.errorPopup.errorMessage
export default Slice.reducer
